import type { DeliverySettingsAPIDeliveryOptionCode } from 'src/services/delivery-settings/types/DeliverySettingsAPIDeliveryOptionCode';

interface GetDeliveryOptionMessageArgs {
  cutoffMessage?: string;
  dateMessage?: string;
  optionCode: DeliverySettingsAPIDeliveryOptionCode;
  providerName?: string;
  range?: string;
}

export const getDeliveryOptionMessage = ({
  cutoffMessage,
  dateMessage,
  optionCode,
  providerName,
  range,
}: GetDeliveryOptionMessageArgs): string => {
  let message = 'Delivery';

  if (range) {
    message = cutoffMessage
      ? `Order by ${cutoffMessage} for delivery within ${range} days from dispatch`
      : `Delivery within ${range} days from dispatch`;
  }

  if (dateMessage) {
    if (optionCode === 'SATURDAY') {
      message = cutoffMessage
        ? `Order by ${cutoffMessage} for delivery on ${dateMessage}`
        : `Delivery on ${dateMessage}`;
    } else {
      message = cutoffMessage
        ? `Order by ${cutoffMessage} for delivery on or before ${dateMessage}`
        : `Delivery on or before ${dateMessage}`;
    }
  }

  if (providerName && providerName !== 'Other Provider') {
    message = `${message}, via ${providerName}`;
  }

  return message;
};
